@if (!isRegisteredAccount) {
  <form
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="firstName">{{ 'UI.Common.FirstName' | translate }}</label>
          <input
            id="firstName"
            type="text"
            class="form-control"
            formControlName="firstName"
          />
          @if (firstName.invalid && (firstName.dirty || firstName.touched)) {
            <div class="alert alert-danger">
              @if (firstName.errors.required) {
                <div translate>First Name is required.</div>
              }
              @if (firstName.errors.notEmptyOrWhitespace) {
                <div>
                  {{ 'UI.Common.FirstName' | translate }}
                  {{ 'cannot be empty or whitespace' | translate }}.
                </div>
              }
              @if (firstName.errors.jip_firstName) {
                <div translate>
                  {{ errorMessage ? errorMessage.firstName : '' }}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="lastName">{{ 'UI.Common.LastName' | translate }}</label>
          <input
            id="lastName"
            type="text"
            class="form-control"
            formControlName="lastName"
          />
          @if (lastName.invalid && (lastName.dirty || lastName.touched)) {
            <div class="alert alert-danger">
              @if (lastName.errors.required) {
                <div translate>Last Name is required.</div>
              }
              @if (lastName.errors.notEmptyOrWhitespace) {
                <div translate>
                  {{ 'UI.Common.LastName' | translate }}
                  {{ 'cannot be empty or whitespace' | translate }}.
                </div>
              }
              @if (lastName.errors.jip_lastName) {
                <div translate>
                  {{ errorMessage ? errorMessage.lastName : '' }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="username"> {{ 'Username' | translate }}</label>
      <input
        id="username"
        type="text"
        class="form-control"
        formControlName="username"
      />
      @if (username.invalid && (username.dirty || username.touched)) {
        <div class="alert alert-danger">
          @if (username.errors.required) {
            <div translate>User Name is required.</div>
          }
          @if (username.errors.notEmptyOrWhitespace) {
            <div>
              {{ 'Username' | translate }}
              {{ 'cannot be empty or whitespace' | translate }}.
            </div>
          }
          @if (username.errors.cannotContainWhitespace) {
            <div>
              {{ 'Username' | translate }}
              {{ 'cannot contain whitespace' | translate }}.
            </div>
          }
          @if (username.errors.jip_username) {
            <div translate>
              {{ errorMessage ? errorMessage.username : '' }}
            </div>
          }
        </div>
      }
      <small>
        {{ 'UI.Validation.NoSpace' | translate }}
      </small>
    </div>
    <div class="form-group">
      <label
        for="email"
        translate
        >Email</label
      >
      <input
        id="email"
        type="text"
        class="form-control"
        formControlName="email"
      />
      @if (email.invalid && (email.dirty || email.touched)) {
        <div class="alert alert-danger">
          @if (email.errors.required) {
            <div translate>Email is required.</div>
          }
          @if (email.errors.email) {
            <div translate>
              {{ 'Invalid email address' }}
            </div>
          }
          @if (email.errors.jip_email) {
            <div translate>
              {{ errorMessage ? errorMessage.email : '' }}
            </div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label
        for="password"
        translate
        >Password</label
      >
      <div class="position-relative">
        @if (showPasswordStrength) {
          <app-password-strength
            [password]="password?.value || ''"
          ></app-password-strength>
        }
      </div>
      <div class="input-group">
        <input
          id="password"
          [type]="passwordDisplayed ? 'text' : 'password'"
          class="form-control password-validation"
          formControlName="password"
          (focus)="onPasswordFocus()"
          (blur)="onPasswordBlur()"
        />
        <div class="input-group-text">
          <button
            class="btn-unstyled d-flex align-items-center"
            (click)="togglePassword($event)"
          >
            <ng-icon
              [name]="passwordDisplayed ? 'matVisibilityOff' : 'matVisibility'"
              aria-hidden="true"
            ></ng-icon>
          </button>
        </div>
      </div>
      @if (password.invalid && (password.dirty || password.touched)) {
        <div class="alert alert-danger">
          @if (password.errors.required) {
            <div>
              {{ 'UI.Validation.PasswordIsRequired' | translate }}
            </div>
          }
          @if (password.errors.notEmptyOrWhitespace) {
            <div translate>
              {{ 'Password' | translate }}
              {{ 'cannot be empty or whitespace' | translate }}.
            </div>
          }
          @if (password.errors.jip_password) {
            <div translate>
              {{ errorMessage.password }}
            </div>
          }
        </div>
      }
      <small>
        {{ 'UI.Validation.PasswordHint' | translate }}
        <b><span>#$^+=!*()&#64;%&.,+-_<></span></b></small
      >
    </div>
    <div class="form-group">
      <label
        class="d-block"
        for="passwordRepeat"
        translate
        >Re-type Password</label
      >
      <div class="input-group">
        <input
          id="passwordRepeat"
          [type]="passwordRepeatIsShow ? 'text' : 'password'"
          class="form-control"
          formControlName="passwordRepeat"
        />
        <div class="input-group-text">
          <button
            class="btn-unstyled d-flex align-items-center"
            (click)="togglePasswordRepeat($event)"
          >
            <ng-icon
              [name]="
                passwordRepeatIsShow ? 'matVisibilityOff' : 'matVisibility'
              "
              aria-hidden="true"
            ></ng-icon>
          </button>
        </div>
      </div>
      @if (
        passwordRepeat.invalid &&
        (passwordRepeat.dirty || passwordRepeat.touched)
      ) {
        <div class="alert alert-danger">
          @if (passwordRepeat.errors.required) {
            <div>
              {{ 'UI.Validation.PasswordIsRequired' | translate }}
            </div>
          }
        </div>
      }
      @if (
        passwordRepeat.value &&
        loginForm.errors?.passwordNotSame &&
        (passwordRepeat.dirty || passwordRepeat.touched)
      ) {
        <div class="alert alert-danger">
          <div translate>Password does not match.</div>
        </div>
      }
    </div>
    <div class="form-group confirm-account-recaptcha">
      <app-google-recapcha [formInput]="loginForm"></app-google-recapcha>
    </div>
    <div class="form-group">
      <div class="form-check mb-4">
        <app-term-agreement-checkbox
          [termOfUseUrl]="termOfUseUrl"
          [portalName]="portalName"
          formControlName="termAgreement"
        ></app-term-agreement-checkbox>
      </div>
    </div>
    @if (
      loginForm.errors &&
      loginForm.errors[formErrorKey] &&
      (loginForm.dirty || loginForm.touched)
    ) {
      <div
        class="alert alert-danger"
        translate
      >
        <div [innerHTML]="errorMessage[formErrorKey] | safeHtml"></div>
      </div>
    }

    @if (accountNotActivated) {
      <app-info-notice containerClass="mb-3">
        <div>
          <span>
            {{
              'Registration.UserNotActivated'
                | translate
                | stringReplacement: { '{portalName}': portalName }
            }}
          </span>

          <a
            href=""
            class="text-dark text-underline d-block"
            appDebounceClick
            (debounceClick)="resendNotActivatedEmail()"
            [class.pe-none]="isResending"
          >
            @if (isResending) {
              <span
                class="spinner-border spinner-border-sm me-1"
                aria-hidden="true"
              ></span>
            }
            {{ 'UI.RegisterEvent.ResendEmail' | translate }}
          </a>
        </div>
      </app-info-notice>
    }

    <div class="form-group text-center">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="
          !loginForm.valid ||
          isSubmitting ||
          isSubmitted ||
          !(loginForm?.touched || loginForm?.dirty)
        "
      >
        @if (isSubmitting) {
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        }
        <span translate> Register</span>
      </button>
    </div>
  </form>
} @else {
  <div class="email-confirmation">
    <div class="email-confirmation__info mt-4">
      <span
        class="info-text"
        [innerHTML]="
          'UI.Registration.Inform-email-sent'
            | translate
            | stringReplacement
              : {
                  '{portalName}': portalUrl | linkWrapper: portalName,
                  '{userEmail}':
                    this.sentEmailAddress | emailWrapper: this.sentEmailAddress,
                }
        "
      ></span>
      <span
        class="info-text"
        translate
        >UI.Registration.Inform-follow-link</span
      >
      <span class="mt-3">
        <b translate>UI.Registration.Didnot-receive-email</b>
        <span
          class="ms-2"
          translate
          >UI.Registration.Please-check-your-spam</span
        >
      </span>
    </div>
    <div class="form-group text-center email-confirmation__buttons">
      <button
        type="button"
        appDebounceClick
        (debounceClick)="resendConfirmationEmail(this.sentEmailAddress)"
        class="btn btn-secondary"
        [disabled]="isSubmitting"
      >
        @if (isSubmitting) {
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        }
        <span>{{ 'UI.Registration.ResendEmail' | translate }}</span>
      </button>
      <a
        href="/"
        class="btn btn-primary ms-3 text-decoration-none"
      >
        {{ 'UI.Registration.OK' | translate }}
      </a>
    </div>
  </div>
}
